<template>
  <Select
    :value="id"
    :clearable="clearable"
    @on-clear="clear"
    :multiple="multiple"
    @on-change='ddddd'
  >
    <Option v-for="(x, index) in wanggeList" :value="x.id" :key="index">{{
      x.name
    }}</Option>
  </Select>
  
</template>
<script>
export default {
  props: ["id","clearable","multiple"],
  data() {
    return {
      wanggeList: [],
      m:[]
    };
  },
  methods: {
    ddddd(v) {
      this.$emit("update:id", v);
      this.$emit("update:name", '');
    },
    clear(v) {
      this.$emit("update:id", "");
      this.$emit("update:name", "");
    },
    getWange() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.wanggeList = data;
      });
    },
  },
  model: {
    prop: "id",
    event: "ddddd",
  },
  mounted() {
    this.getWange();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/common/selectPoint.vue